import dateService from '../services/util/dateService'
import loggingService from '../services/util/loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'mediaService'
var path = '/Media/'
var isDebug = false

const mediaType = {}
mediaType.FieldworkRequest = 1
mediaType.FileSearch = 2
mediaType.CulturalResourceShapeFile = 3
mediaType.CulturalResourceSupportingDocuments = 4
mediaType.CulturalResourceImages = 5
mediaType.CulturalResourceSketchMap = 6
mediaType.CulturalResourceLabResults = 7
mediaType.CulturalResourceCorrespondence = 8
mediaType.Isolate = 9
mediaType.SiteNumberRequest = 10
mediaType.InvestigationShapeFiles = 11
mediaType.InvestigationReports = 12
mediaType.InvestigationSupportingDocuments = 13
mediaType.InvestigationCorrespondence = 14
mediaType.InvestigationImages = 15
mediaType.UndertakingDiscoveryPlan = 16
mediaType.UndertakingDataDiscoveryPlan = 17
mediaType.UndertakingVisualContrastRating = 18
mediaType.UndertakingComplianceCheck = 19
mediaType.UndertakingHabsHaerRecord = 20
mediaType.ReconForm = 21
mediaType.ReconFormImage = 22
mediaType.ReconFormSupportDoc = 23
mediaType.FieldworkRequestLetter = 24
mediaType.FileSearchLetter = 25
mediaType.InvestigationLetter = 26
mediaType.SiteNumberRequestLetter = 27
mediaType.CulturalResourceRecordingLetter = 28
mediaType.IsolateLetter = 29
mediaType.BuildingSurveyLetter = 30
mediaType.CulturalResourceMaterialSourcing = 31
mediaType.SiteFormPDF = 32
mediaType.UndertakingAuthorization = 33
mediaType.UndertakingMoa = 34
mediaType.UndertakingPa = 35
mediaType.UndertakingLetter = 36
mediaType.MoaLetter = 37
mediaType.PaLetter = 38
mediaType.FileSearchReport = 39
mediaType.E106ComplianceShapeFile = 40
mediaType.E106ComplianceImage = 41
mediaType.E106ComplianceLetter = 42
mediaType.E106SupportingDocuments = 43
mediaType.Moa = 44
mediaType.MoaSupportingDocuments = 45
mediaType.Pa = 46
mediaType.PaSupportingDocuments = 47
mediaType.UserSignature = 48
mediaType.UndertakingSupportingDocuments = 49
mediaType.CulturalResourceProdScannedReport = 50
mediaType.UndertakingShapeFiles = 51
mediaType.MoaAnnualReport = 52
mediaType.MoaMeetings = 53
mediaType.MoaOther = 54
mediaType.PaAnnualReport = 55
mediaType.PaMeetings = 56
mediaType.PaOther = 57
mediaType.E106TopograpicMap = 59

const mediaSubtype = {}
mediaSubtype.SiteOverviewImage = 1
mediaSubtype.ArtifactImage = 2
mediaSubtype.FeatureImage = 3
mediaSubtype.RockArtImage = 4
mediaSubtype.BuildingImage = 5
mediaSubtype.OtherImage = 6
mediaSubtype.InvestigationOtherImage = 7
mediaSubtype.RadioCarbon = 8
mediaSubtype.MaterialSourcing = 9
mediaSubtype.OtherLabResults = 10
mediaSubtype.ViewShed = 11

function list (http, mediaTypeId, mediaSubtypeId, parentId) {
    loggingService.log(isDebug, serviceName, `list - mediaTypeId: ${mediaTypeId}, mediaSubtypeId: ${mediaSubtypeId}, parentId: ${parentId}`)
    var requestUrl = `${path}List?mediaTypeId=${mediaTypeId}&parentId=${parentId}`

    if (mediaSubtypeId) {
        requestUrl = requestUrl + `&mediaSubtypeId=${mediaSubtypeId}`
    }
    return http.get(requestUrl).then(function (response) {
        _.forEach(response.data, function (value, key) {
            value.shapeFileProcessingCompleteDate = dateService.convertToDate(value.shapeFileProcessingCompleteDate)
            value.createdDate = dateService.convertToDate(value.createdDate)
        })
        return response
    })
}

function get (http, mediaId, mediaTypeId, mediaSubtypeId, parentId) {
    loggingService.log(isDebug, serviceName, `get - mediaId: ${mediaId}, mediaTypeId: ${mediaTypeId}, mediaSubtypeId: ${mediaSubtypeId}, parentId: ${parentId}`)
    var requestUrl = `${path}Get?mediaId=${mediaId}&mediaTypeId=${mediaTypeId}&parentId=${parentId}`
    if (mediaSubtypeId) {
        requestUrl = requestUrl + `&mediaSubtypeId=${mediaSubtypeId}`
    }
    return http.get(requestUrl, { responseType: 'arraybuffer' })
}

function getHtmlToPdfFile (http, pdfHtmlFileDto) {
    loggingService.log(isDebug, serviceName, 'getHtmlToPdfFile')

    //var data = JSON.stringify(html)

    //return http.post(path + 'GetHtmlToPdfFile', pdfHtmlFileDto, { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, responseType: 'arraybuffer' })
    return http.post(path + 'GetHtmlToPdfFile', pdfHtmlFileDto, { responseType: 'arraybuffer' })
}

//letter generation
function generateLetterPdf (http, generateLetterPdfDto) {
    loggingService.log(isDebug, serviceName, 'generateLetterPdf')
    return http.post(path + 'GenerateLetterPdf', generateLetterPdfDto, { responseType: 'arraybuffer' })
}

//letter generate and save file to server
function generateLetterPdfSave (http, generateLetterPdfDto) {
    loggingService.log(isDebug, serviceName, 'generateLetterPdfSave')
    return http.post(path + 'GenerateLetterPdfSave', generateLetterPdfDto, { responseType: 'arraybuffer' })
}

//This is an axios response object that contains a downloaded file
function saveFileToDownload (response, filename) {
    var blob = new Blob([response.data], { type: response.headers['content-type'] })
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
}

function putFile (http, mediaTypeId, mediaSubtypeId, parentId, fileToUpload, comment) {
    loggingService.log(isDebug, serviceName, 'putFile for mediaTypeId: ' + mediaTypeId + ', parentId: ' + parentId)

    var data = new FormData()
    data.append('mediaTypeId', mediaTypeId)
    if (mediaSubtypeId) {
        data.append('mediaSubtypeId', mediaSubtypeId)
    }
    data.append('parentId', parentId)
    data.append('file', fileToUpload)
    data.append('comment', comment)

    return http.post(path + 'PutFile', data).then(function (response) {
        loggingService.log(isDebug, serviceName, 'putFile.then')
        return response
    })
}

function saveUserSignature (http, parentId, fileToUpload) {
    loggingService.log(isDebug, serviceName, 'saveUserSignature for userId: ' + parentId)

    var data = new FormData()
    data.append('mediaTypeId', mediaType.UserSignature)
    data.append('parentId', parentId)
    data.append('file', fileToUpload)
    data.append('comment', '')

    return http.post(path + 'SaveUserSignature', data).then(function (response) {
        return response
    })
}

//Remove media by mediaId.  Cannot handle removing shapefiles yet due to dependencies
function removeByMediaId (http, mediaId) {
    loggingService.log(isDebug, serviceName, 'removeByMediaId for : ' + mediaId)
    return http.delete(path + `RemoveByMediaId?mediaId=${mediaId}`)
}

function listMediaNotification (http) {
    return http.get(path + `ListMediaNotification`).then(result => {
        result.data.forEach(x => { x.createdDate = dateService.convertToDate(x.createdDate) })
        return result
    })
}

function archiveMediaNotification (http, mediaNotificationId) {
    return http.put(path + `ArchiveMediaNotification?mediaNotificationId=${mediaNotificationId}`)
}

export default {
    get: get,
    list: list,
    mediaType: mediaType,
    mediaSubtype: mediaSubtype,
    saveFileToDownload: saveFileToDownload,
    putFile: putFile,
    saveUserSignature: saveUserSignature,
    removeByMediaId: removeByMediaId,
    getHtmlToPdfFile: getHtmlToPdfFile,
    generateLetterPdf: generateLetterPdf,
    generateLetterPdfSave: generateLetterPdfSave,
    listMediaNotification: listMediaNotification,
    archiveMediaNotification: archiveMediaNotification
}



// WEBPACK FOOTER //
// ./src/services/mediaService.js